import basicSearchkeywordvue from './basicSearchKeyword.vue';
export default {
  components: {
    basicSearchkeywordvue: basicSearchkeywordvue
  }
};